import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-squared-minus",
  "use": "svg_i-squared-minus-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"svg_i-squared-minus\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2ZM0 4a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Zm12.5 6a1 1 0 0 0 0-2h-7a1 1 0 0 0 0 2h7Z\" fill=\"#20BEE8\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol